module.exports = __webpack_public_path__ + "img/星链数据横版定稿.f063a35e.svg";